import { bookingAdapter } from '../adapters/booking';

import type {
  IPayloadMakeBooking,
  IMakeBooking,
  IBookingData,
  MakeBookingResponse,
} from '@/entities/booking/model/types';
import type { HeadRequest, IStandardResponse } from '@/entities/common/types/api';

import type { HttpClient } from '../http';

interface IConfirmBookingQuery {
  code: string;
  phoneNumber: string;
}

class BookingRepository {
  private http: HttpClient;

  constructor(http: HttpClient) {
    this.http = http;
  }

  public async makeBooking(payload: IPayloadMakeBooking): Promise<IMakeBooking> {
    try {
      const data = await this.http.post<IMakeBooking>('/booking', payload);

      return data;
    } catch (error: unknown) {
      console.error(error);

      return {
        code: 0,
        data: {
          bookingCode: null,
        },
        message: error instanceof Error ? error.message : 'Ошибка записи к врачу',
        isError: true,
      };
    }
  }

  public async confirmBooking(query: IConfirmBookingQuery): Promise<IMakeBooking> {
    try {
      const data = await this.http.get<IMakeBooking>('/booking/confirm', {}, query);

      return data;
    } catch (error: unknown) {
      console.error(error);

      return {
        code: 0,
        data: {
          bookingCode: null,
        },
        isError: true,
        message: error instanceof Error ? error.message : 'Ошибка записи к врачу',
      };
    }
  }

  public async checkExistBooking(code: string): Promise<HeadRequest | null> {
    try {
      const data = await this.http.head<HeadRequest>(`/booking/${code}`);

      return data;
    } catch (error) {
      console.error('Error fetching booking data:', error);

      return null;
    }
  }

  public async getBookingData(code: string): Promise<IBookingData | null> {
    try {
      const data = await this.http.get<IStandardResponse<IBookingData>>(`/booking/${code}`);

      return bookingAdapter(data.data);
    } catch (error) {
      console.error('Error fetching booking data:', error);

      return null;
    }
  }

  public async cancelBookingData(code: string): Promise<MakeBookingResponse> {
    try {
      const data = await this.http.get<MakeBookingResponse>(`/booking/${code}/cancel`);

      return data;
    } catch (error: unknown) {
      console.error('Error cancelling booking:', error);

      return {
        code: 0,
        isError: true,
        message: error instanceof Error ? error.message : 'Ошибка отмены записи к врачу',
      };
    }
  }
}

export { BookingRepository };
